// extracted by mini-css-extract-plugin
module.exports = {"baseLayout":"index_baseLayout__1WKkE","container":"index_container__23IXY","content":"index_content__3KnS0","tips":"index_tips__3CeHt"};